import React, { useEffect, useState } from 'react';
import { api } from '../services/api';

const TYPE_CLASS = {
  info: 'alert-info',
  success: 'alert-success',
  warning: 'alert-warning',
  critical: 'alert-danger',
};

const PlatformMessagesBanner = ({ surface }) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const loadMessages = async () => {
      if (!surface) return;
      try {
        const response = await api.get('/acct-mgmt/v1/platform/messages', { params: { surface } });
        if (!cancelled) setMessages(response.data?.messages || []);
      } catch (err) {
        if (!cancelled) setMessages([]);
      }
    };
    loadMessages();
    return () => {
      cancelled = true;
    };
  }, [surface]);

  if (messages.length === 0) return null;

  return (
    <div className="w-100" style={{ maxWidth: surface === 'id_portal' ? '520px' : undefined }}>
      {messages.map((message, index) => {
        const isLastAccountMessage = surface === 'account_portal' && index === messages.length - 1;
        return (
        <div
          key={message.id}
          className={`alert ${TYPE_CLASS[message.message_type] || 'alert-info'} ${isLastAccountMessage ? 'mb-0' : 'mb-3'}`}
          role="status"
        >
          <div className="fw-semibold">{message.title}</div>
          <div>{message.message_body}</div>
        </div>
        );
      })}
    </div>
  );
};

export default PlatformMessagesBanner;
